<template>
  <div>
    <el-dialog
      title="配置日志"
      width="800px"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        <el-table v-loading="loading" :data="tableData" style="width: 100%">
          <el-table-column label="操作时间" prop="operationTime" width="100px"></el-table-column>
          <el-table-column label="操作类型" prop="operationType"></el-table-column>
          <el-table-column label="操作来源" prop="operationSource">
            <template slot-scope="scope">
              {{ scope.row.operationSource || '-' }}
            </template>
          </el-table-column>
          <el-table-column label="操作内容摘要" prop="operationSummary"></el-table-column>
          <el-table-column label="操作结果" prop="operationResult" width="100px"></el-table-column>
          <el-table-column label="失败原因/详情" width="120px">
            <template slot-scope="scope">
              <el-button type="text" @click="handleDetail(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </el-dialog>
    <ConfigurationLogDetailDialog ref="configurationLogDetailDialogRef" />
  </div>
</template>
<script>
import { postPublishLogPage } from '@/api/device/log'
import ConfigurationLogDetailDialog from './configurationLogDetailDialog.vue'
export default {
  name: 'configurationLogDialog',
  components: {
    ConfigurationLogDetailDialog
  },
  data() {
    return {
      dialogVisible: false,
      gatewayDeviceId: '', // 网关设备ID
      tableData: [], // 列表数据
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页条数
      total: 0, // 列表数据总条数
      loading: false
    }
  },
  methods: {
    // 初始化弹窗，接收父组件传入的 row 对象
    init(row) {
      this.gatewayDeviceId = row?.deviceId || ''
      this.dialogVisible = true
      this.currentPage = 1
      this.queryList()
    },
    // 分页查询配置日志
    async queryList() {
      if (!this.gatewayDeviceId) return
      this.loading = true
      try {
        const res = await postPublishLogPage({
          gatewayDeviceId: this.gatewayDeviceId,
          current: this.currentPage,
          size: this.pageSize
        })
        const data = res.data?.data || {}
        this.tableData = data.records || []
        this.total = data.total || 0
      } catch (e) {
        console.error('查询配置日志失败：', e)
      } finally {
        this.loading = false
      }
    },
    // 关闭弹窗并重置数据
    handleClose() {
      this.dialogVisible = false
      this.tableData = []
      this.total = 0
      this.currentPage = 1
      this.gatewayDeviceId = ''
    },
    // 每页条数改变时触发
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.queryList()
    },
    // 当前页变时触发
    handleCurrentChange(val) {
      this.currentPage = val
      this.queryList()
    },
    handleDetail(row) {
      this.$refs.configurationLogDetailDialogRef.init(row)
    }
  }
}
</script>
<style scoped lang="scss">
.operate-container {
  padding-top: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
